import React from 'react'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import MESSAGE from '../../../business-const/Message/Message'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'



export const InformacoesOpcionaisNaoAfetamCalculo = () => {

    return (
        <GridContainer>
            <GridItem12
                className={CLASSNAME().helpTextInLine}
            >
                {HELPTEXT.informacoesOpcionaisNaoAfetamCalculo}
            </GridItem12>
        </GridContainer>
    )
}



export const MensagemDadosObrigatoriosClienteDevemSerInformados = ({ vars }) => {

    return (
        <h1
            className='mt-10 ml-5 text-white'
        >
            {vars.jsonConfiguracao && vars.jsonConfiguracao.tornarCpfClienteObrigatorio
                ?
                    vars.jsonConfiguracao.tornarEmailClienteObrigatorio
                    ?
                        MESSAGE().dadosObrigatoriosClienteDevemSerInformadosComCpfComEmail
                    :
                        MESSAGE().dadosObrigatoriosClienteDevemSerInformadosComCpf
                :
                    vars.jsonConfiguracao && vars.jsonConfiguracao.tornarEmailClienteObrigatorio
                        ?
                            MESSAGE().dadosObrigatoriosClienteDevemSerInformadosComEmail
                        :
                            MESSAGE().dadosObrigatoriosClienteDevemSerInformados
            }
        </h1>
    )
}